// extracted by mini-css-extract-plugin
export default {"melodyVideo":"pN-z","isFullWidth":"qN-z","landingPageVideo":"rN-z","play":"sN-z","iframeVideo":"tN-z","playHidden":"uN-z","fullwidth":"vN-z"};